import React from 'react';
import {useDroppable} from '@dnd-kit/core';
import {rectSortingStrategy, SortableContext, useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import _ from 'lodash';

import {connect} from 'redux/index.js';

import {Image} from '@henrybuilt/react-lib';

const SortableImage = ({id, url, draggingId, extra, style, extraStyles, ...rest}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    transition: {
      duration: 500, // milliseconds
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const styles = {
    image: {
      transform: CSS.Translate.toString(transform),
      transition,
      cursor: isDragging ? 'grabbing' : 'grab',
      ...style,
    },
    wrapper: {width: '100%', height: '100%'}
  };

  return (
    <>
      {!isDragging ? <Image
        {...{extra, extraStyles}}
        src={url}
        key={`sortable-image-${id}`}
        style={styles.image}
        wrapperStyle={styles.wrapper}
        {...{id}}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        disableHover={draggingId !== null}
      />
        : <Image
          src={url}
          key={`dragging-image-${id}`}
          style={styles.image}
          wrapperStyle={styles.wrapper}
          {...{id}}
          ref={setNodeRef}
          {...attributes}
          {...listeners}
          disableHover={draggingId !== null}
        />}
    </>
  );
};

const SortableImageGrid = ({id, items, media, hasLoaded, draggingId, gridStyle, getImageStyle, getExtras, getExtraStyles, ...rest}) => {
  const {setNodeRef} = useDroppable({id});

  return (
    <SortableContext {...{id, items: _.map(items, 'id')}} strategy={rectSortingStrategy}>
      <div style={gridStyle} ref={setNodeRef}>
        {items.map(({id}) => {
          const url = _.find(media, {id})?.url;

          return (
            <SortableImage
              {...{id, url, draggingId}}
              key={`sortable-item-${id}`}
              extra={getExtras?.(id)}
              extraStyles={getExtraStyles?.(id)}
              style={getImageStyle?.(id)}
            />
          );
        })}
      </div>
    </SortableContext>
  );
};

export default connect({
  mapState: state => {
    return {
      media: state.resources.media.byId,
    };
  }
})(SortableImageGrid);
